import { PayoutInfo as KitPayoutInfo } from "lola-framework-ui-test";
import type { CSSProperties, JSX } from "react";
import { useStore } from "../../../../store/globalState";

/**
 * Chevron ("Pagar con", "Recibir en", Support rows) follows --foreground so it
 * stays visible on dark cards. `color` is kept in the props for API
 * compatibility with callers but no longer drives the chevron.
 * The matching CSS hook lives in flavor-c/styles.css (.payout-info--fg-chevron).
 */
const CHEVRON_COLOR = "var(--foreground)";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  /** Accepted for compatibility; the chevron always uses --foreground. */
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
  style?: CSSProperties;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange,
  fee,
  className = "",
  style,
}) => {
  const { theme } = useStore();
  const { backgroundBtn } = theme.whiteView;

  return (
    <KitPayoutInfo
      title={title}
      subtitle={subtitle}
      icon={icon}
      onChange={onChange}
      iconColor={CHEVRON_COLOR}
      fee={fee}
      className={`payout-info--fg-chevron ${className}`.trim()}
      style={{ ...style, "--bg": backgroundBtn } as CSSProperties}
      showBackArrow={!fee}
    />
  );
};
